import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Store, Loader2 } from "lucide-react";
import { motion } from "framer-motion";

const BG = "https://images.unsplash.com/photo-1768734836223-82f8930babee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHw0fHxsb2NhbCUyMHN0cmVldCUyMG1hcmtldCUyMHByb2R1Y2V8ZW58MHx8fHwxNzg2MTk0MTE4fDA&ixlib=rb-4.1.0&q=85";

export default function FirstAccess() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const { setUser, setAdminExists } = useAuth();
  const navigate = useNavigate();
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", form);
      setUser(data); setAdminExists(true);
      toast.success("Conta criada! Bem-vindo(a).");
      navigate("/painel", { replace: true });
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      <div className="relative hidden lg:block">
        <img src={BG} alt="feira" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/70" />
        <div className="relative z-10 h-full flex flex-col justify-end p-12 text-white">
          <Store className="w-10 h-10 mb-4 text-primary" />
          <h2 className="font-display text-4xl font-black leading-tight">Controle o crediário da sua loja sem complicação</h2>
          <p className="mt-3 text-white/70 text-lg">Fichas, parcelas, comprovantes e cobranças — tudo em um só lugar.</p>
        </div>
      </div>

      <div className="flex items-center justify-center p-6">
        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md">
          <div className="lg:hidden w-12 h-12 rounded-2xl bg-primary flex items-center justify-center mb-5"><Store className="w-6 h-6 text-primary-foreground" /></div>
          <h1 className="font-display text-3xl sm:text-4xl font-black text-primary">Primeiro acesso</h1>
          <p className="text-muted-foreground mt-2 mb-8">Crie a conta do administrador para começar.</p>
          <form onSubmit={submit} className="space-y-5">
            <div><Label className="text-muted-foreground">Seu nome / nome da loja</Label><Input data-testid="register-name" className="mt-1.5 rounded-xl bg-card" style={{ height: 52 }} value={form.name} onChange={set("name")} placeholder="Ex.: Mercadinho do Zé" required /></div>
            <div><Label className="text-muted-foreground">E-mail</Label><Input data-testid="register-email" type="email" className="mt-1.5 rounded-xl bg-card" style={{ height: 52 }} value={form.email} onChange={set("email")} placeholder="voce@email.com" required /></div>
            <div><Label className="text-muted-foreground">Telefone (com DDD)</Label><Input data-testid="register-phone" className="mt-1.5 rounded-xl bg-card" style={{ height: 52 }} value={form.phone} onChange={set("phone")} placeholder="+55 11 99999-9999" required /></div>
            <div><Label className="text-muted-foreground">Senha</Label><Input data-testid="register-password" type="password" className="mt-1.5 rounded-xl bg-card" style={{ height: 52 }} value={form.password} onChange={set("password")} placeholder="Crie uma senha" required /></div>
            <Button data-testid="register-submit" disabled={loading} className="w-full rounded-full text-lg font-semibold" style={{ height: 56 }}>{loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Criar conta e entrar"}</Button>
          </form>
        </motion.div>
      </div>
    </div>
  );
}
